/**
 * author: Ananthapadmanabhan V K
 */
import { useNavigate } from "react-router-dom";
// import LogoutService from "./LogoutService";

export default class ErrorHandlingService {
  static handleError(status) {
    switch (status) {
      case 401:
        this.logout();
        break;

      default:
        break;
    }
  }

  static logout = () => {
    const navigate = useNavigate();
    localStorage.clear();
    navigate("/login");
  };
}
